import { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Box,
  Tooltip,
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
} from "@mui/material";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";
// import DateTime from "../../utils/dateTime/DateTime";
import { Constants } from "../../constants/Constants";
import { Link, useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState(localStorage.getItem("authKey"));
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [userName, setUserName] = useState(
    localStorage.getItem("loginuserName")
  );
  const[entityType,setEntityType]=useState(
    localStorage.getItem("entityType")
  )

  const[Name,setName]=useState(
    localStorage.getItem("Name")
  )
  console.log("Name",Name)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("authKey");
    localStorage.removeItem("userId");

    navigate("/login");
    setToken(null);
    handleClose();
  };

  useEffect(() => {
    let timeout;
    const setExpiration = () => {
      timeout = setTimeout(() => {
        localStorage.removeItem("authKey");
        localStorage.removeItem("userId");
        navigate("/login");
        setToken(null);
      }, 20 * 60 * 1000); // 20 minutes
    };

    if (token) {
      setExpiration();
    }

    const handleActivity = () => {
      clearTimeout(timeout);

      if (token) {
        setExpiration();
      }
    };

    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keypress", handleActivity);

    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keypress", handleActivity);
      clearTimeout(timeout);
    };
  }, [token]);

  return (
    <Grid container alignItems="center">
    <Grid item xs={12} sm={6}>
      <Box>
        <Typography variant="h6" component="div" sx={{ fontWeight: "bold" }}>
          {Constants.welcomeText} 
        </Typography>
        <Typography variant="h6" component="div" sx={{ fontWeight: "bold" }}>
          {Name} ({entityType})
        </Typography>
        {/* <DateTime /> */}
      </Box>
    </Grid>
  
    <Grid item xs={12} sm={6}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 1.5, // Ensures even spacing
        }}
      >
        <Tooltip title="Notifications">
          <Link to="#">
            <NotificationsNoneOutlinedIcon sx={{ fontSize: 30, color: "white" }} />
          </Link>
        </Tooltip>
  
        <Tooltip title="Settings">
          <Link to="/setting">
            <SettingsOutlinedIcon sx={{ fontSize: 30, color: "white" }} />
          </Link>
        </Tooltip>
  
        {/* <Tooltip title="Help Center">
          <Link to="#">
            <HelpOutlineOutlinedIcon sx={{ fontSize: 30, color: "white" }} />
          </Link>
        </Tooltip> */}
  
        <IconButton onClick={handleClick} sx={{ color: "white" }}>
          <Tooltip title="Profile">
            <AccountCircleIcon fontSize="medium" />
          </Tooltip>
        </IconButton>
  
        <Menu
          sx={{
            marginTop: "2rem",
            minWidth: 100,
            "& .MuiMenuItem-root": {
              padding: "6px 12px",
              fontSize: "0.875rem",
            },
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          {/* <MenuItem onClick={() => navigate("/change-password")}>
            <ListItemIcon>
              <LockIcon fontSize="small" />
            </ListItemIcon>
            <Link to="change-password">
              <Typography>Change Password</Typography>
            </Link>
          </MenuItem> */}
          <MenuItem
            onClick={() => {
              localStorage.removeItem("token");
              window.location.href = "/";
            }}
          >
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            <Typography>Logout</Typography>
          </MenuItem>
        </Menu>
      </Box>
    </Grid>
  </Grid>
  
  );
};

export default Header;
